var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:'btn-twitter' + _vm.componentKey,staticClass:"btn-twitter"},[_c('a',{staticClass:"twitter-share-button",attrs:{"data-lang":_vm.lang.params.toLowerCase(),"href":"https://twitter.com/share?ref_src=twsrc%5Etfw","data-text":"ミュージアム展示ガイドアプリ「ポケット学芸員」","data-url":"http://welcome.mapps.ne.jp/pocket","data-show-count":"false"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-134df36c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/BtnTwitter.vue
// module id = null
// module chunks = 